module.exports = __webpack_public_path__ + "static/media/logo-amex.99f845ba.svg";